module.exports = __webpack_public_path__ + "img/youtube.606666a1.svg";